<template>
    <div class="main-block">
        <h2 class="main-title">
            <span>Моделювання виплат</span>
        </h2>
        <div class="main-block sim_block">
            <div class="sim_content">
                <div class="sim_descr">
                    <p>Скористайтеся моделюванням виплат, щоб побачити розмір відшкодувань який Ви могли б отримати, якщо б скористувались програмою Метеозахист в минулі роки.</p>
                </div>
                <div class="form_box">
                    <region-select
                        :lang="lang"
                        :regions="regions"
                        @region-selected="regionSelected
                    "/>
                    <crop-select
                        :lang="lang"
                        :crops="crops"
                        @crop-selected="cropSelected
                    "/>
                </div>
                <div class="form_box">
                    <div class="form_item ">
                        <p class="form_item_title">
                            <span>Програма</span></p>
                        <div class="list-tit disabled">
                            <li class="list-item">
                                <div class="list-body">
                                    <div class="text-nowrap py-2 company-name disabled">{{ programName }}</div>
                                </div>
                            </li>
                        </div>
                    </div>
                </div>
                <div class="form_box"></div>
                    <meteo-points-map
                        :center="mapCenter"
                        :zoom="zoom"
                        :meteo-points="meteoPointsArray"
                        @meteo-point-selected="meteoPointSelected"
                    />
                <div class="form_box" v-if="canShowAllInfo">
                    <div class="simulator_phase_wrapper active">
                        <risk-period-select
                            :risk-periods-load-url="riskPeriodsLoadUrl"
                            :region-id="selectedRegionId"
                            :crop-id="selectedCropId"
                            :meteo-point-id="selectedMeteoPointId"
                            @risk-period-selected="riskPeriodSelected"
                        />

                        <limits
                            :limits="limitsData"
                        />
                        <div class="form_text form_text-w">
                            <p class="form_text_title">Кількість днів спеки</p>
                        </div>
                        <div class="sim_graf">
                            <heat-days-chart
                                v-if="historicalData !== null && limitsData !== null"
                                :historical-data="historicalData"
                                :limits-data="limitsData"
                            />
                        </div>
                        <div class="form_text form_text-w">
                            <p class="form_text_title">Кількість опадів, мм</p>
                        </div>
                        <div class="sim_graf">
                            <div class="sim_graf_chart sim_graf_chart-rain">
                                <rain-days-chart
                                    v-if="historicalData !== null && limitsData !== null"
                                    :historical-data="historicalData"
                                    :limits-data="limitsData"
                                />
                            </div>
                        </div>
                        <div class="sim_price">
                            <p class="sim_price_title">Рівень покриття на період  цвітіння</p>
                            <p class="sim_price_undertitle"></p>
                            <div class="sim_price_scale">
                                <vue-range-slider
                                    :step="5"
                                    :min="rangeLimits.min"
                                    :max="rangeLimits.max"
                                    :width="200"
                                    :tooltip="false"
                                    v-model="insurancePrice"
                                ></vue-range-slider>
                                <div class="sim_price_scale_text"><b>{{ insurancePrice }}</b><span>$/Га</span></div>
                            </div>

                        </div>
                        <div class="form_text form_text-w">
                            <p class="form_text_title">Графік потенційних відшкодувань</p>
                            <p class="form_text_undertitle">Якщо фактична погода була гірша за граничний рівень – Ви отримали б повне або часткове відшкодування ваших витрат у межах обраного Вами рівня покриття як показано на графіку нижче.</p>
                        </div>
                        <div class="sim_graf">
                            <div class="sim_graf_chart">
                                <insurance-coverage-chart
                                    v-if="historicalData !== null && limitsData !== null"

                                    :insurance-price="insurancePrice"
                                    :historical-data="historicalData"
                                    :limits-data="limitsData"
                                />
                            </div>
                        </div>
                        <weather-archive
                            v-if="historicalData !== null && limitsData !== null"
                            :historical-data="historicalData"
                            :limits-data="limitsData"
                        />
                    </div>
                </div>
                <div class="form_item form_item-w form_item-button">
                    <button v-if="!canShowAllInfo" class="form_item_button form_item_button-blue" disabled="">Створити анкету</button>
                    <button v-else class="form_item_button form_item_button-blue" @click.prevent="goToApplicationCreatePage">Створити анкету</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CropSelectComponent from "./CropSelectComponent";
export default {
    name: "SimulatorContainer",
    components: {
        CropSelectComponent,
    },

    props: {
        lang: String,
        meteoPointsLoadUrl: String,
        riskPeriodsLoadUrl: String,
        limitsLoadUrl: String,
        historicalLoadUrl: String,
        rangeLimitsLoadUrl: String,
        applicationCreateUrl: String,

        crops: Array,
        regions: Array,
        rangeLimits: Object,
        programName: String,
    },

    mounted() {
        //
    },

    data: function () {
        return {
            selectedCropId: null,
            selectedRegionId: null,
            selectedMeteoPointId: null,
            selectedRiskPeriodId: null,
            meteoPointsArray: null,
            mapCenter: { lat: 49.26, lng: 32.03 },
            zoom: 7,
            limitsData: null,
            historicalData: null,
            insurancePrice: 20,
            rangeTooltip: false,
        };
    },

    watch: {
        selectedRiskPeriodId(val) {
            this.loadLimits();
            this.historicalData = null;
            this.loadHistorical();
        },

        selectedMeteoPointId(val) {
            this.loadLimits();
            this.loadHistorical();
        },


    },

    computed: {
        canShowAllInfo() {
            return this.selectedCropId !== null && this.selectedRegionId !== null && this.selectedMeteoPointId !== null;
        }
    },

    methods: {
        cropSelected(cropId) {
            this.selectedCropId = cropId;
        },

        regionSelected(regionId, center) {
            this.selectedRegionId = regionId;

            this.mapCenter = {
                lat: parseFloat(center.split(',')[0]),
                lng: parseFloat(center.split(',')[1]),
            };

            this.updateMeteoPoints();
        },

        meteoPointSelected(meteoPointId) {
            this.selectedMeteoPointId = meteoPointId;
        },

        riskPeriodSelected(riskPeriodId) {
            this.selectedRiskPeriodId = riskPeriodId;
        },

        updateMeteoPoints() {
            if(this.selectedRegionId !== null) {
                this.loadMeteoPoints();
            }
        },

        loadMeteoPoints() {
            axios.get(this.meteoPointsLoadUrl, {
                params: {
                    region_id: this.selectedRegionId,
                }
            }).then((response) => {
                this.meteoPointsArray = response['data']['data'];
            }).catch((error) => {
                this.$eventBus.$emit('alert', 'error', 'Під час завантаження дани виникла помилка!');
            });
        },

        loadLimits() {
            if(this.selectedMeteoPointId !== null && this.selectedRiskPeriodId !== null && this.selectedCropId !== null) {
                axios.get(this.limitsLoadUrl, {
                    params: {
                        risk_period_id: this.selectedRiskPeriodId,
                        crop_id: this.selectedCropId,
                        meteo_point_id: this.selectedMeteoPointId
                    }
                }).then((response) => {
                    this.limitsData = response['data']['data'];
                }).catch((error) => {
                    this.$eventBus.$emit('alert', 'error', 'Під час завантаження дани виникла помилка!');
                });
            }
        },

        loadHistorical() {
            if(this.selectedRiskPeriodId !== null && this.selectedMeteoPointId !== null) {
                axios.get(this.historicalLoadUrl, {
                    params: {
                        risk_period_id: this.selectedRiskPeriodId,
                        meteo_point_id: this.selectedMeteoPointId,
                    }
                }).then((response) => {
                    this.historicalData = response['data']['data'];
                }).catch((error) => {
                    this.$eventBus.$emit('alert', 'error', 'Під час завантаження дани виникла помилка!');
                });
            }
        },

        goToApplicationCreatePage() {
            window.location.href = this.applicationCreateUrl;
        }

    }
}
</script>

<style scoped>

</style>
